import { shiftMonitoringDate } from "./timeMonitoringUtils";

const byCount = (a, b) => b.scheduled - a.scheduled || a.name.localeCompare(b.name);

export function schedulingBookingView(buckets, dates) {
  const daily = new Map(dates.map((day) => [day, 0]));
  const weeks = new Map();
  const weekForDay = new Map();
  dates.forEach((day) => {
    const weekday = new Date(`${day}T12:00:00Z`).getUTCDay();
    const week = shiftMonitoringDate(day, -((weekday + 6) % 7));
    if (!weeks.has(week)) {weeks.set(week, weeks.size);}
    weekForDay.set(day, weeks.get(week));
  });
  const people = new Map(), areas = new Map(), counties = new Map();
  let total = 0;
  buckets.forEach((bucket) => {
    if (!daily.has(bucket.day)) {return;}
    total += bucket.scheduled;
    daily.set(bucket.day, daily.get(bucket.day) + bucket.scheduled);
    if (!people.has(bucket.userId)) {
      people.set(bucket.userId, { id: bucket.userId, name: bucket.name, scheduled: 0, weekly: new Array(weeks.size).fill(0) });
    }
    const person = people.get(bucket.userId);
    person.scheduled += bucket.scheduled;
    person.weekly[weekForDay.get(bucket.day)] += bucket.scheduled;
    if (!areas.has(bucket.workAreaId)) {
      areas.set(bucket.workAreaId, { id: bucket.workAreaId, name: bucket.areaName, scheduled: 0 });
    }
    areas.get(bucket.workAreaId).scheduled += bucket.scheduled;
    const countyKey = `${bucket.state}|${bucket.county}`;
    if (!counties.has(countyKey)) {
      counties.set(countyKey, { state: bucket.state, county: bucket.county, scheduled: 0 });
    }
    counties.get(countyKey).scheduled += bucket.scheduled;
  });
  return {
    total,
    daily: Array.from(daily, ([day, scheduled]) => ({ day, scheduled })),
    people: Array.from(people.values()).sort(byCount),
    areas: Array.from(areas.values()).sort(byCount),
    counties: Array.from(counties.values()).sort((a, b) => b.scheduled - a.scheduled || `${a.state}|${a.county}`.localeCompare(`${b.state}|${b.county}`)),
  };
}
